// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3QUkC","insightsList":"newBusinessInsightsMenu_insightsList__INLTJ","active":"newBusinessInsightsMenu_active__2FMDM"};